import React        from 'react'

const Container = props => {
    return (
        <div className="blogs-container">
            { props.children }
        </div>
    )
}

export default Container
